module.exports = __webpack_public_path__ + "img/maplist_icon.d073c75b.svg";